import type { AccountType, Customer, PaginatedApiResponse } from 'types';
import { baseQuery } from '../baseQuery';

type CustomerSearchParams = {
  filter?: AccountType | '';
  searchParam: 'all' | 'name' | 'id' | 'email' | 'address' | 'mobile' | 'phone' | 'parent_company_name';
  searchValue: string;
  page?: number;
  recordsPerPage?: number;
};

export const getCustomerSearch = async ({
  filter,
  searchParam,
  searchValue,
  page,
  recordsPerPage,
}: CustomerSearchParams) => {
  const data: PaginatedApiResponse<Customer[]> = await baseQuery(
    `customer-search?search_param=${searchParam}&page=${
      page || 1
    }&search_value=${searchValue}&records_per_page=${recordsPerPage || 5}${filter ? `&filter=${filter}` : ''}`,
  );

  return data;
};
